// skipcq: JS-W1028
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../utils/firebase';
import {
  SCHEDULER_DASHBOARD_COLLECTION,
  SCHEDULER_SLO_SNAPSHOT_DOC,
} from '../utils/firestoreCollections';
import { mapFirestoreSloPayload } from '../utils/schedulerSloSnapshotMap';

function useSchedulerSloSnapshot() {
  const [snapshotState, setSnapshotState] = useState(null);
  const [snapshotLoading, setSnapshotLoading] = useState(true);
  const [snapshotError, setSnapshotError] = useState(null);

  useEffect(() => {
    const snapshotRef = doc(db, SCHEDULER_DASHBOARD_COLLECTION, SCHEDULER_SLO_SNAPSHOT_DOC);
    const unsubscribe = onSnapshot(
      snapshotRef,
      (snapshot) => {
        if (!snapshot.exists()) {
          setSnapshotState(null);
        } else {
          const enriched = snapshot.data();
          setSnapshotState(mapFirestoreSloPayload(enriched));
        }
        setSnapshotLoading(false);
        setSnapshotError(null);
      },
      (subscriptionError) => {
        console.error('useSchedulerSloSnapshot subscription error', subscriptionError);
        setSnapshotError(subscriptionError);
        setSnapshotLoading(false);
      },
    );
    return () => unsubscribe();
  }, []);

  return {
    sloSnapshot: snapshotState,
    loading: snapshotLoading,
    error: snapshotError,
  };
}

export default useSchedulerSloSnapshot;
